import React, { useEffect, useState } from "react";
import { Switch, Route, useHistory } from "react-router-dom";
import Home from "Page/Home";
import About from "Page/About";
import Notfound from "Page/Notfound";
import MetaContainer from "Components/Containers/MetaContainer";
import Header from "Components/Header";
import styled from "styled-components";
import AppProvider from "Provider/AppProvider";
import Planet from "Page/Planet";
import Loading from "Components/Loading";
import BrowserSupport from "Page/BrowserSupport";
import { checkBrowser } from "./util";
import AboutProvider from "Provider/AboutProvider";

const AppWrapper = styled.div`
	${(props) => props.theme.color.appBg};
	${(props) => props.theme.layout.full_height_layout};
	overflow: hidden;
`;

const App: React.FC = () => {
	const { push } = useHistory();
	const [browserCheck, setBrowserCheck] = useState<boolean | null>(null);

	useEffect(() => {
		const calcFullHeight = () => {
			// We execute the same script as before
			let vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty("--vh", `${vh}px`);
		};
		window.addEventListener("resize", calcFullHeight);
		calcFullHeight();
		return () => {
			window.removeEventListener("resize", calcFullHeight);
		};
	}, []);

	useEffect(() => {
		const check = async () => {
			const result = checkBrowser();
			if (result === "11.0" || result === "10.0" || result === "9.0") {
				setBrowserCheck(false);
			} else {
				setBrowserCheck(true);
			}
		};
		check();
	}, [push]);

	return (
		<AppWrapper>
			<AppProvider>
				<MetaContainer />

				{browserCheck === true && (
					<>
						<Header />
						<Home />
						<Switch>
							<Route path="/planet" component={Planet} />
							<Route
								path="/about"
								render={() => (
									<AboutProvider>
										<About />
									</AboutProvider>
								)}
							/>
							<Route path="/notfound" component={Notfound} />
						</Switch>

						<Loading />
					</>
				)}

				{browserCheck === false && <BrowserSupport />}
			</AppProvider>
		</AppWrapper>
	);
};

export default App;
